import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class CashAdjustmentLineService extends BaseApiTemplateService<any> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-adjustment-lines/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-adjustment-lines/backoffice-ep";
        this.httpClient = http;
      }
    
}